module.exports = __webpack_public_path__ + "assets/img/changzhou.22026842.png";